var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 263,
    height: 40,
    viewBox: "0 0 263 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 40,
    transform: "translate(794.81 2592.259)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-802.81 -2592.259)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(892.81 2621.259)",
    fontSize: 20,
    fontFamily: "MicrosoftJhengHeiBold, Microsoft JhengHei"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Drag Left or Right")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(798.809 2595.259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.348,792.593V781.662c0-1.8-.007-3.6,0-5.4a2.006,2.006,0,0,1,1.945-2.217,1.986,1.986,0,0,1,2.057,2.176c.019,3.04.006,6.08.006,9.12,0,.2,0,.406.009.607.023.416.214.7.66.691s.618-.309.636-.718c.009-.2.007-.406.007-.608,0-3.806,0-7.612.007-11.417a4.107,4.107,0,0,1,.16-1.262,1.955,1.955,0,0,1,2.093-1.253,2.007,2.007,0,0,1,1.721,1.742,5.828,5.828,0,0,1,.022.742q0,5.777,0,11.553c0,.2-.064.446.024.6.141.241.4.6.585.585.252-.025.518-.318.694-.558.1-.135.032-.393.032-.595,0-3.536-.009-7.071,0-10.606a1.981,1.981,0,0,1,2.741-1.985,1.855,1.855,0,0,1,1.2,1.583,10.225,10.225,0,0,1,.029,1.079q0,5.607,0,11.214c0,.113,0,.225,0,.338.009.464.113.9.676.9s.655-.435.653-.906q-.007-4.054,0-8.107a2.026,2.026,0,0,1,2.454-2.207,1.911,1.911,0,0,1,1.549,1.888c0,6.349.107,12.7-.116,19.046-.158,4.474-3.341,7.554-7.79,8.13a16.738,16.738,0,0,1-6.431-.368,10.123,10.123,0,0,1-6.055-4.237c-2.12-3.157-4.222-6.328-6.277-9.528a3.517,3.517,0,0,1-.518-1.833A2.089,2.089,0,0,1,100.7,787.8a2.534,2.534,0,0,1,2.767.93c.81,1.051,1.576,2.137,2.363,3.207C105.959,792.113,106.1,792.28,106.348,792.593Z",
    transform: "translate(-81.077 -771.36)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.244 13.013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.5,795.563l4.031-4.031L151.5,787.5",
    transform: "translate(-147.469 -787.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.063,
    transform: "translate(0 4.031)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.013)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 8.063,
    transform: "translate(0 4.031)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.531,795.563,75.5,791.531l4.031-4.031",
    transform: "translate(-75.5 -787.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.d875a3352ae71cff18b385abb6b7c100.svg";
export { ForwardRef as ReactComponent };